var $ = jQuery.noConflict();

// Webpack Imports
import * as bootstrap from 'bootstrap';
gsap.registerPlugin(ScrollTrigger);

// Sticking class on scroll
const primaryHeader = document.querySelector(".site-header");
if (primaryHeader) {
	const scrollWatcher = document.createElement("div");

	scrollWatcher.setAttribute("data-scroll-watcher", "");
	primaryHeader.before(scrollWatcher);

	const navObserver = new IntersectionObserver(
		(entries) => {
			primaryHeader.classList.toggle("sticky-active", !entries[0].isIntersecting);
		},
		{ rootMargin: "50px 0px 0px 0px" }
	);

	navObserver.observe(scrollWatcher);
}


// Divers
$(".dropdown-menu").hover(function() {
    $(".dropdown-menu").toggleClass("hovered");
});

$(".dropdown-menu.hovered").hover(function() {
    $(".nav-link").setAttribute(
        'aria-expanded', 
        `${!($(".nav-link").getAttribute('aria-expanded') === 'true')}`
    );
});

$(document).ready(function(){
	$("#footer_newsletter form input[type='submit']").after("<span class='input'></span>");// Ajout span pour style du bouton Submit dans les formulaire contact, newsletter... 
    $("#career_form form .gform_footer input[type='submit']").after("<span class='input'></span>");
    $("#contact_form form .gform_footer input[type='submit']").after("<span class='input'></span>");
    $("#devis_form form .gform_footer input[type='submit']").after("<span class='input'></span>");
    $( ".wp-block-button .wp-block-button__link" ).wrapInner( "<span></span>"); // ajoute un span sur les blocs button Gutenberg
    $( ".dash-left" ).wrapInner( "<span></span>");
});

// GSAP home
if($("body").hasClass("home")) {
    gsap.fromTo("#quisommesnous .bg-size-contain", {
        x: -200,
        opacity: 0,
        delay: 1,
        duration: 2
    }, {
        scrollTrigger: {
            trigger: "#hero_home .somocap-btn",
            start: "top center",
        },
        x: 0,
        opacity: 1,
    });

    gsap.fromTo("#quisommesnous .col-md-6:nth-of-type(2)", {
        opacity: 0,
        delay: 1,
        duration: 5
    }, {
        scrollTrigger: {
            trigger: "#hero_home .somocap-btn",
            start: "top center",
        },
        opacity: 1,
    });

    gsap.fromTo("#footer_newsletter", {
        y: 500,
        opacity: 0,
        duration: 3
    }, {
        scrollTrigger: {
            trigger: "#actualites .somocap-btn",
            start: "top center",
        },
        y: 0,
        opacity: 1,
    });

    gsap.set('#expertises .card', {
        opacity: 0,
        y: 0,
        scale: .95,
    });

    gsap.set('#marches img', {
        opacity: 0,
        y: 0,
        scale: .95,
    });

    gsap.set('#marches h3', {
        opacity: 0,
        y: 0,
        scale: .95,
    });

    gsap.set('#actualites .card', {
        opacity: 0,
        y: 0,
        scale: .95,
    });

    ScrollTrigger.batch('.card-wrapper', {
    onEnter: batch => {
        batch.forEach((card, index) => gsap.to(card.children, {opacity: 1, y: 0, scale: 1, stagger: 0.25, delay: index * 0.3}))
    },
    once: true
    });

    ScrollTrigger.batch('#marches a', {
        onEnter: batch => {
            batch.forEach((img, index) => gsap.to(img.children, {opacity: 1, y: 0, scale: 1, stagger: 0.25, delay: index * 0.3}))
        },
        once: true
    });

    ScrollTrigger.batch('.actualites-wrapper', {
        onEnter: batch => {
            batch.forEach((card, index) => gsap.to(card.children, {opacity: 1, y: 0, scale: 1, stagger: 0.25, delay: index * 0.3}))
        },
        once: true
    });
}

// Smooth scroll
const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
})

function raf(time) {
lenis.raf(time);
requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

// Carrousel Historique page Qui sommes-nous
if($("body").hasClass("page-template-quisommesnous")) {
    var multipleCardCarousel = document.querySelector("#historyCarousel");
    if (window.matchMedia("(min-width: 768px)").matches) {
        var historyCarousel = new bootstrap.Carousel(multipleCardCarousel, {
            interval: false,
        });

        var carouselWidth = $(".carousel-inner")[0].scrollWidth;
        var cardWidth = $(".carousel-item").width();
        var scrollPosition = 0;

        $("#historyCarousel .carousel-control-next").on("click", function () {
            if (scrollPosition < carouselWidth - cardWidth * 5) {
            scrollPosition += cardWidth;
            $("#historyCarousel .carousel-inner").animate(
                { scrollLeft: scrollPosition },
                600
            );
            }
        });

        $("#historyCarousel .carousel-control-prev").on("click", function () {
            if (scrollPosition > 0) {
                scrollPosition -= cardWidth;
                $("#historyCarousel .carousel-inner").animate(
                    { scrollLeft: scrollPosition },
                    600
                );
            }
        });
    } 
    else {
        $(multipleCardCarousel).addClass("slide");
    }
}

//Compteurs chiffres page Nos engagements
if($("body").hasClass("page-template-engagements")) {
    $('.circle span').counterUp({
        time: 1000
    });
}

// JavaScript optionnel pour contrôler la vidéo avec l'API YouTube
// À ajouter dans votre footer ou dans un fichier JS

// Chargement de l'API YouTube
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var player;

// Callback appelé quand l'API est prête
function onYouTubeIframeAPIReady() {
    if (document.getElementById('youtube-bg-video')) {
        player = new YT.Player('youtube-bg-video', {
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        });
    }
}

function onPlayerReady(event) {
    // Assure que la vidéo est en sourdine et démarre
    event.target.mute();
    event.target.playVideo();
}

function onPlayerStateChange(event) {
    // Relance la vidéo si elle se termine (sécurité pour la boucle)
    if (event.data === YT.PlayerState.ENDED) {
        event.target.playVideo();
    }
}

// Pause la vidéo quand l'onglet n'est pas visible (économie de bande passante)
document.addEventListener('visibilitychange', function() {
    if (player && typeof player.pauseVideo === 'function' && typeof player.playVideo === 'function') {
        if (document.hidden) {
            player.pauseVideo();
        } else {
            player.playVideo();
        }
    }
});

class Accordion {
  constructor(domNode) {
    this.rootEl = domNode;
    this.buttonEl = this.rootEl.querySelector(
      "#accordionFAQ button[aria-expanded]"
    );

    const controlsId = this.buttonEl.getAttribute("aria-controls");
    this.contentEl = document.getElementById(controlsId);

    this.open = this.buttonEl.getAttribute("aria-expanded") === "true";

    // add event listeners
    this.buttonEl.addEventListener("click", this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.toggle(!this.open);
  }

  toggle(open) {
    // don't do anything if the open state doesn't change
    if (open === this.open) {
      return;
    }

    // update the internal state
    this.open = open;

    // handle DOM updates
    this.buttonEl.setAttribute("aria-expanded", `${open}`);
    if (open) {
      this.contentEl.removeAttribute("hidden");
    } else {
      this.contentEl.setAttribute("hidden", "");
    }
  }

  // Add public open and close methods for convenience
  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }
}

// init accordions
const accordions = document.querySelectorAll(".accordion h3");
accordions.forEach((accordionEl) => {
  new Accordion(accordionEl);
});
